import { useDarkModeContext } from "@/hooks/contextHooks/useDarkModeContext";

type ModuleType =
  | "clone"
  | "cloneIcon"
  | "add/remove"
  | "trash"
  | "title"
  | "card"
  | "container"
  | "body"
  | "icon"
  | "actionIcon"
  | "actionDots"
  | "header"
  | "footer"
  | "selectedProject"
  | "project"
  | "dueDate"
  | "dueDateText"
  | "standardBtn"
  | "rowA"
  | "rowB"
  | "selectedRow"
  | "selectBtn"
  | "sail"
  | "sailBtn"
  | "infoIcon"
  | "infoIconBackground"
  | "editIcon"
  | "editBackground";

export const useDarkModeColors = () => {
  const { isDarkMode } = useDarkModeContext();
  const getColor = (module: ModuleType) => {
    if (module === "clone") {
      return isDarkMode ? "#201b41" : "#f0f0f0";
    } else if (module === "cloneIcon") {
      return isDarkMode ? "#ffffff" : "#201b41";
    } else if (module === "add/remove") {
      return isDarkMode ? "#b2b2b2" : "#ffffff";
    } else if (module === "trash") {
      return isDarkMode ? "#ff0000" : "#ff0000";
    } else if (module === "title") {
      return isDarkMode ? "#ffffff" : "#201b41";
    } else if (module === "card") {
      return isDarkMode ? "#686868" : "#f0f0f0";
    } else if (module === "container") {
      return isDarkMode ? "#292929" : "#ffffff";
    } else if (module === "body") {
      return isDarkMode ? "#292929" : "#ffffff";
    } else if (module === "icon") {
      return isDarkMode ? "#ffffff" : "#201b41";
    } else if (module === "actionIcon") {
      return isDarkMode ? "#f0f0f0" : "#201b41";
    } else if (module === "actionDots") {
      return isDarkMode ? "#201b41" : "#f0f0f0";
    } else if (module === "header") {
      return isDarkMode ? "#686868" : "#f5f5f5";
    } else if (module === "footer") {
      return isDarkMode ? "#686868" : "#201b41";
    } else if (module === "selectedProject") {
      return isDarkMode ? "#686868" : "#f0f0f0";
    } else if (module === "project") {
      return isDarkMode ? "#404040" : "#ffffff";
    } else if (module === "dueDate") {
      return isDarkMode ? "#f0f0f0" : "#201b41";
    } else if (module === "dueDateText") {
      return isDarkMode ? "#201b41" : "#f0f0f0";
    } else if (module === "standardBtn") {
      return isDarkMode ? "#b2b2b2" : "#ffffff";
    } else if (module === "rowA") {
      return isDarkMode ? "#404040" : "#f0f0f0";
    } else if (module === "rowB") {
      return isDarkMode ? "#616161" : "#e1e1e1";
    } else if (module === "selectedRow") {
      return isDarkMode ? "#939393" : "#D2F3FF";
    } else if (module === "selectBtn") {
      return isDarkMode ? "#201b41" : "#939393";
    } else if (module === "sail") {
      return isDarkMode ? "#686868" : "#f5f5f5";
    } else if (module === "sailBtn") {
      return isDarkMode ? "#292929" : "#201b41";
    } else if (module === "infoIconBackground") {
      return isDarkMode ? "#f0f0f0" : "#201b41";
    } else if (module === "infoIcon") {
      return isDarkMode ? "#201b41" : "#f0f0f0";
    } else if (module === "editIcon") {
      return isDarkMode ? "#f0f0f0" : "#201b41";
    } else if (module === "editBackground") {
      return isDarkMode ? "#f0f0f0" : "#201b41";
    }
  };
  return { getColor };
};
